export const toPlainString = (value) => {
  if (typeof value === "string") return value;
  if (value === null || value === undefined) return "";
  return String(value);
};

export const stripControlCharacters = (input, replacement = " ") => {
  const str = toPlainString(input);
  if (!str) return str;

  let mutated = "";
  let mutatedAtLeastOnce = false;

  for (const char of str) {
    const codePoint = char.codePointAt(0);
    if (codePoint !== undefined && (codePoint <= 0x1f || codePoint === 0x7f)) {
      mutated += replacement;
      mutatedAtLeastOnce = true;
    } else {
      mutated += char;
    }
  }

  return mutatedAtLeastOnce ? mutated : str;
};
